import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=c88c8616&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c88c8616')) {
      api.createRecord('c88c8616', component.options)
    } else {
      api.reload('c88c8616', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=c88c8616&", function () {
      api.rerender('c88c8616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8Hu7SuLd9NOnc/JS/comp/pricelist.vue"
export default component.exports